import { render, staticRenderFns } from "./EquipTable.vue?vue&type=template&id=48722fde"
import script from "./EquipTable.vue?vue&type=script&lang=js"
export * from "./EquipTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports